import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { apiGet } from "../services/apiServices";
import { endPoints } from "../configs/apiUrls";
import { login, logout, setUser } from "../redux/slices/authSlice";


const useAuthCheck = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const checkAuth = async () => {
            const userData = await apiGet(endPoints.VERIFY_TOKEN)

            if (userData?.success) {
                // If token exists, consider user as logged in
                dispatch(login());
                dispatch(setUser({ ...userData?.user, token: userData?.token }));
            } else {
                dispatch(logout());
            }
        };

        checkAuth();
    }, [dispatch]);
};

export default useAuthCheck;
